<template>
  <div id="thomsonwrapper-sj" class="thomsonwrapper-sj thomson-app">

    <div class="pf4-preselection">

      <div class="pf4-level pf4-level1" :class="{ 'pf4-level--selected': preselection.isSelected }">
        <PreselectionBox v-for="(box, index) in filteredPreselectionBoxes" :key="'preselection.box' + index" :data="box" @click.native="boxClick(index)" v-show="boxIsDisplayed(index)"/>
      </div>

    </div>

    <template v-for="(tool, index) in tools" :key="'tool' + index">
      <Tool v-show="tool.isSelected" :data="tool" />
    </template>

  </div>
</template>

<script>
// Components
import PreselectionBox from "../common/PreselectionBox.vue";
import Tool from "../common/Tool.vue"

// Mixins
import locale from "../../mixins/common/locale"
import queryStringFilter from "../../mixins/common/query-string-filter" //! Note: This MUST come before storage mixin
import storage from "../../mixins/common/storage"

// Helpers
import { mapState, mapActions } from "vuex";
import "../../../node_modules/glyphicons-only-bootstrap/css/bootstrap.min.css";

export default {
  name: 'App',
  components: {
    PreselectionBox,
    Tool
  },
  mixins: [locale, queryStringFilter, storage],
  data() {
    return {
      tloUrl: process.env.VUE_APP_TLO_URL,
      isDistributor: process.env.VUE_APP_TYPE === "distributor",
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    // this.trackPageview();
    this.updateCmsSelectorVisibility();
  },
  computed: {
    
    ...mapState([
      "isMobile",
      "preselection",
    ]),
    
    globalSettings() { return window.thomsonSettings; },

    filteredPreselectionBoxes() { return this.isDistributor ? this.preselection.boxes.filter(box => box.toolType != "ContactThomson") : this.preselection.boxes },

    // Create a tool component for every preselection box that does not have a redirectUrl, and that is not hidden in the global settings "hideWrapperBoxes" property
    tools() { return this.preselection.boxes.filter(box => !box.hasOwnProperty('redirectUrl') && (!this.globalSettings.hasOwnProperty('hideWrapperBoxes') || !this.globalSettings.hideWrapperBoxes.includes(box.toolType.toLowerCase()))) }

  },
  methods: {

    ...mapActions([
      "updateMobile",
    ]),

    onResize() {
      this.updateMobile(window.innerWidth);
    },
    
    boxIsDisplayed(box) {
      // On Mobile we need to hide preselection boxes that are not being used. This function handles that logic.
      // First determine if there are any selected boxes in the row.
      let aBoxIsSelectedInTheRow = this.preselection.boxes.filter(x => x.isSelected === true).length > 0

      // now return the answer. Box is visible if any of the following conditions are true:
      // * it's selected
      // * the user is on Desktop (not mobile)
      // * no boxes are selected in the row.  This means that the user needs to see all boxes in order to make a selection
      // * the box is not set to only show in certain regions, or the user is in the region specified
      // * the global settings does not have a "hideWrapperBoxes" property, or the box toolType is not in the list of tools to hide
      return (this.preselection.boxes[box].isSelected || !this.isMobile || !aBoxIsSelectedInTheRow) && 
        (!this.preselection.boxes[box].hasOwnProperty('showInRegion') || this.preselection.boxes[box].showInRegion.includes(this.region)) &&
        (!this.globalSettings.hasOwnProperty('hideWrapperBoxes') || !this.globalSettings.hideWrapperBoxes.includes(this.preselection.boxes[box].toolType.toLowerCase()));
    },

    boxClick(sourceBox) {
      if (this.preselection.boxes[sourceBox].hasOwnProperty('redirectUrl')) {
        let redirectUrl = this.$t(this.preselection.boxes[sourceBox].redirectUrl);
        let url = `${redirectUrl.startsWith('http') ? '' : this.tloUrl}${redirectUrl}`
        window.open(url, "_blank")
      } else {
        this.$store.dispatch("updatePreselectionBox", { sourceBox, isSelected: !this.preselection.boxes[sourceBox].isSelected });
        // TODO: Save state to session storage
      }

      this.updateCmsSelectorVisibility();

      this.$store.dispatch("trackEvent", { 
        action: "Click - Pre-selection level1",
        label: "box: " + this.preselection.boxes[sourceBox].apiName
      })

    },

    updateCmsSelectorVisibility() {
      let selectorBox = this.preselection.boxes.find(box => box.toolType == 'Old-Selector');
      let cmsSelectorContainer = document.querySelector('#screw-jack-selector-container');
      if (cmsSelectorContainer && selectorBox && selectorBox.isSelected) {
        // Show CMS selector
        cmsSelectorContainer.style.display = "block";
      } else if (cmsSelectorContainer) {
        // Hide CMS selector
        cmsSelectorContainer.style.display = "none";
      }
    }

  },
}
</script>

<style lang="scss">
@font-face {
  font-family: "ProximaNova";
  src: url("https://www.thomsonlinear.com/fonts/ProximaNova-Regular.eot");
  src: url("https://www.thomsonlinear.com/fonts/ProximaNova-Regular.eot?#iefix") format("embedded-opentype"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Regular.woff") format("woff"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Regular.ttf") format("truetype"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Regular.svg#ProximaNova-Regular") format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "ProximaNova";
  src: url("https://www.thomsonlinear.com/fonts/ProximaNova-Bold.eot");
  src: url("https://www.thomsonlinear.com/fonts/ProximaNova-Bold.eot?#iefix") format("embedded-opentype"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Bold.woff") format("woff"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Bold.ttf") format("truetype"), url("https://www.thomsonlinear.com/fonts/ProximaNova-Bold.svg#ProximaNova-Bold") format("svg");
  font-weight: 700;
  font-style: normal;
}
.thomsonwrapper-sj {
  @import '../../css/app.scss';

  width: 100%;
  margin: 0 auto;
  background-color: white;
}

// Hide the preselection heading on the selector
.thomson-app .pf4-preselection-heading:not(.wrapper-heading) {
  display: none !important;
}
</style>

<style scoped lang="scss">
.thomson-app {
  @import '../../css/preselection.scss';
}
</style>